const FoodNewsData = [
    {
        id: 1,
        images: 'images/img/adult-blur-blurred-background-687824.png',
        title: 'First Delevery',
        favIcon: 'images/ICON/Group 204.png',
        description: 'Keep your systems in sync with automated web hook based notification each time link is paid and how  we dream about our future.'
    },
    {
        id: 1,
        images: 'images/img/chef-cook-food-33614.png',
        title: 'A Good Auto Responder',
        favIcon: 'images/ICON/Group 1133.png',
        description: 'Keep your systems in sync with automated web hook based notification each time link is paid and how  we dream about our future.'
    },
    {
        id: 1,
        images: 'images/img/architecture-building-city-2047397.png',
        title: 'Home Delivery',
        favIcon: 'images/ICON/Group 245.png',
        description: 'Keep your systems in sync with automated web hook based notification each time link is paid and how  we dream about our future.'
    },
]

export default FoodNewsData;